// extracted by mini-css-extract-plugin
export default {"descriptionContainer":"ZLNCrtHhTccGJflLXVxz"};